import React from 'react';

function AboutSectionSummary() {
  return (
    <section id="about" className="bg-[#161616] px-5 py-20 sm:px-6 md:px-12 md:py-24 lg:px-20 lg:py-32">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-16 lg:gap-20">
          <div className="reveal">
            <h2 className="bank-gothic text-xs tracking-[0.5em] text-neutral-500 mb-6 uppercase">About Us</h2>
            <h3 className="bank-gothic text-lg mb-8">Ideas into works of art.</h3>
            <p className="text-xs text-neutral-500 leading-loose font-light">
              Crafting structural masterpieces with a focus on longevity, minimalism, and industrial soul.
            </p>
          </div>
          <div className="reveal" style={{ transitionDelay: '150ms' }}>
            <h3 className="bank-gothic text-xs tracking-widest text-neutral-400 mb-8 font-bold">Specialization:</h3>
            <div className="space-y-6">
              <div className="flex items-center space-x-4">
                <div className="w-2 h-2 accent-bg"></div>
                <span className="bank-gothic text-[10px]">Architecture</span>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-2 h-2 accent-bg"></div>
                <span className="bank-gothic text-[10px]">Interiors</span>
              </div>
              <div className="flex items-center space-x-4">
                <div className="w-2 h-2 accent-bg"></div>
                <span className="bank-gothic text-[10px]">Planning</span>
              </div>
            </div>
          </div>
          <div className="reveal" style={{ transitionDelay: '300ms' }}>
            <img 
              src="https://images.unsplash.com/photo-1511818966892-d7d671e672a2?auto=format&fit=crop&q=80&w=800" 
              className="grayscale w-full aspect-square object-cover opacity-50" 
              alt="Architecture" 
              loading="lazy"
              decoding="async"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default AboutSectionSummary;
